/**
 * credentials.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */


import { Hasher } from "../hasher.service";
import { Salter } from "../salter.service";

/**
 * {@link Credentials} are a set of values used to attempt authentication.
 */
export class Credentials
{
  /**
   * Create a new set of {@link Credentials}.
   */
  constructor (private hasher : Hasher, private salter : Salter) {}

  /**
   * The user the credentials are associated with.
   */
  public username : string;

  /**
   * A helper function to use the hashing service.
   *
   * @param {string}  content The content to be hashed
   */
  protected hash (content : string) : string
  {
    return this.hasher.hexOf(content);
  }

  /**
   * A helper function to use the salting service.
   *
   * @param {string}  content The content to be salted
   */
  protected salt (content : string) : string
  {
    return this.salter.salt(content);
  }
}

/**
 * {@link PasswordCredentials} are the standard credentials used to log in.
 */
export class PasswordCredentials extends Credentials
{
  /**
   * The password plaintext
   */
  private _password : string;

  /**
   * Set the password plaintext
   * @param {string}  newPassword
   */
  set password (newPassword : string)
  {
    this._password = newPassword;
  }

  /**
   * Get the password plaintext (returns null because this is disallowed)
   */
  get password () : string
  {
    // Another protection against sending the plaintext across the wire;
    // if we accidentally serialize/JSONify credentials, password is null.
    // NOTE: You still shouldn't serialize this directly, as a policy.
    return "";
  }

  /**
   * Hash and salt the current password, and return the result.
   */
  get hashedPassword () : string
  {
    return this.hash(this.salt(this._password));
  }
}

/**
 * {@link SecurityQuestionCredentials} are the responses used to initiate a
 * password reset for an account. (INCOMPLETE)
 */
export class SecurityQuestionCredentials extends Credentials
{
  public responses : string[];
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/auth/identity/credentials.ts